import React, { useEffect, useState } from 'react';

import { withConfig, withGridConfig } from '../common/Block.jsx';
import { EmptyContentPlaceholder } from '../layout/Builder.jsx';
import { Column, Container, Row } from '../common/Container.jsx';
import { default as Image, ImageSrcSet } from '../common/Image.jsx';
import Layout from '../common/Layout.jsx';
import ScreenSize from '../common/ScreenSize.jsx';

const defaultColumnCount = 4;

function _InstallationPhotosComponent(props) {
    const [id, setId] = useState(undefined);
    useEffect(() => {
        setId(props.blockIdentifier);
    }, [props.blockIdentifier]);

    if (props.data && props.data.length == 0) {
        if (props.builder) {
            return (
                <Container className="cont--inventory">
                    <EmptyContentPlaceholder containerStyle={props.containerStyle} style={props.style}>This show does not have any photos yet! Once you add some, they'll show up here!</EmptyContentPlaceholder>
                </Container>
            );
        }
        return null;
    }
    let content;
    let rowClassName = 'cont--installation__photos';
    if (props.legacy) {
        content = props.data.map((d) => <CellLegacy key={d.id} serverSide={id == undefined} {...props} data={d} />);
    } else {
        let columnCount = props.columnCount || defaultColumnCount;
        let columnSize = props.columnSize;
        if (props.blockConfig && props.blockConfig.block) {
            switch (props.screenSize) {
                case ScreenSize.Mobile:
                    columnCount = props.blockConfig.block.columnsPhone || 2;
                    break;
                case ScreenSize.Tablet:
                    columnCount = props.blockConfig.block.columnsTablet || 3;
                    break;
            }
            columnSize = Layout.columnSize(columnCount);
        }
        content = props.data.map((d, i) =>
            <Cell
                key={d.id}
                index={i}
                listData={props.data}
                serverSide={id == undefined}
                {...props}
                columnCount={columnCount}
                columnSize={columnSize}
                data={d} />
        );
        rowClassName += ' cont__row--custom';
    }
    content = (
        <Container className={!props.inLayout ? "cont--kit__content" : undefined} spaced={true} style={props.style}>
            <Row className={rowClassName}>{content}</Row>
        </Container>
    );
    if (props.containerStyle) {
        content = <div className="cont--kit__wrapper" style={props.containerStyle}>{content}</div>
    }
    return content;
}
const InstallationPhotosComponent =
    withConfig(
        withGridConfig(
            _InstallationPhotosComponent,
            defaultColumnCount,
            { alignment: 'alignment' }));

function Cell(props) {
    let style;
    const columnSpacing = Layout.columnSpacing(props.index, props.columnCount, props.columnSpacing);
    if (columnSpacing) {
        style = { marginLeft: columnSpacing.left, marginRight: columnSpacing.right };
    }
    if (props.listData && props.lineSpacing) {
        if (Layout.shouldUseLineSpacing(props.index, props.listData.length, props.columnCount)) {
            if (!style) {
                style = {};
            }
            style.paddingBottom = props.lineSpacing;
        }
    }
    let className = 'cell--whitelabel cell--whitelabel--installation__photos col--custom';
    if (props.builder) {
        className += ' builder';
    }
    const image = props.data;
    const imageTuples = Image.sizes.map(function (d) {
        const url = Image.url(image, d, d, 'c_fit');
        return { size: d, url: url };
    });
    return (
        <Column className={className} size={props.columnSize}>
            <div className="photo__card" style={style}>
                <ImageSrcSet
                    builder={props.builder}
                    className="photo__card__img"
                    config={props.config}
                    imageTuples={imageTuples}
                    serverSide={props.serverSide} />
            </div>
        </Column>
    );
}

function CellLegacy(props) {
    const image = props.data;
    const imageTuples = Image.sizes.map(function (d) {
        const url = Image.url(image, d, d, 'c_fit');
        return { size: d, url: url };
    });
    return (
        <Column size="3">
            <div className="photo__card">
                <ImageSrcSet
                    builder={props.builder}
                    className="photo__card__img"
                    config={props.config}
                    imageTuples={imageTuples}
                    serverSide={props.serverSide} />
            </div>
        </Column>
    );
}

export default { Component: InstallationPhotosComponent };